import React, { useState, useEffect } from "react";
import SideBarNav from "../sideBar/sideBarNav";
import Loading from "../Loading";
import MainBody from "./mainBody";
import HeaderBar from "../header/headerBar";
import MainFooter from "./mainFooter";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Footer } from "antd/lib/layout/layout";
import FooterBar from "../footer/footerBar";

interface Props {
  children: object;
  noHeader?: boolean;
  firstPage?: boolean;
  title?: string;
  btnBack?: boolean;
}
const LayoutSec: React.FC<Props> = ({
  children,
  noHeader = false,
  firstPage = false,
  btnBack = false,
  title = "",
}) => {
  console.log(useSelector((state: any) => state))
  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value: boolean) => {
    setToggled(value);
  };

  return (
    <>
      <HeaderBar></HeaderBar>
      <div className={`app ${toggled ? "toggled" : ""}`}>
        <MainBody
          title={title}
          noHeader={noHeader}
          firstPage={firstPage}
          btnBack={btnBack}
          handleToggleSidebar={handleToggleSidebar}
        >
          {children}
        </MainBody>
      </div>
      <FooterBar></FooterBar>
    </>
  );
};

export default LayoutSec;
